export default {"src":"/_next/static/media/process-tracking-live.21d2ad22.svg","height":8,"width":8,"blurWidth":0,"blurHeight":0};